export default __webpack_public_path__ + "static/media/ketab.63365992.png";